var map = {
	"./css/VOverride.css": 7167,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./obslogo_dark.png": 2921,
	"./obslogo_light.png": 6917,
	"./obslogo_sm.png": 1698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2764;